
export function patchFetch() {
    if (typeof window === 'undefined' || window._patchedFetch) return

    const originalFetch = window.fetch

    window.fetch = async (input, init) => {
        try {
            var likelyMyAPI = typeof input === 'string' && input.startsWith('/');

            if (likelyMyAPI) {
                const baseUrl = import.meta.env.PROD
                    ? 'https://hub.pittroche.co.uk'
                    : 'https://localhost:7113'
                input = baseUrl + input
            }

            const response = await originalFetch(input, init)

            if (!response.ok && likelyMyAPI) {
                const url = typeof input === 'string' ? input : input.url || ''

                if (response.status === 404) {
                    console.info('[fetch] Allowed 404 (media not found):', url)
                    return response
                }

                if (response.status === 401) {
                    console.info('[fetch] Not Authed 401 :', url)
                    return response;
                } 

                throw new Error(`Fetch failed: ${response.status} ${response.statusText}`)
            }

            return response
        } catch (err) {
            const msg = err?.message || err?.toString?.() || 'Unknown error'

            if (msg.includes('Failed to fetch') || msg.includes('Load failed')) {
                console.info('[fetch] Network failure (likely during deploy):', input)
            } else {
                console.error('[fetch] Unexpected fetch error:', input, err)
            }

            throw err
        }
    }

    window._patchedFetch = true
}
